module.exports = __webpack_public_path__ + "img/ge.5745f290.svg";